import { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHelpers";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";

export default function VendorProfilePage() {
  const { user } = useAuth();
  const [company, setCompany] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/vendors`);
        const mine = (data.items || []).find((v) => v.email === user?.email);
        setCompany(mine || null);
      } catch (err) { if (typeof console !== 'undefined') console.debug('pages/vendor/VendorProfilePage.jsx: swallowed', err); }
    })();
  }, [user]);
  return (
    <div>
      <PageHeader eyebrow="Account" title="Company Profile" />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <Card className="p-6 border-white/10 bg-card">
          <div className="overline mb-3">Account</div>
          <div className="space-y-3">
            <div><Label>Name</Label><Input value={user?.name || ""} readOnly /></div>
            <div><Label>Email</Label><Input value={user?.email || ""} readOnly /></div>
            <div><Label>Phone</Label><Input value={user?.phone || "—"} readOnly /></div>
          </div>
        </Card>
        <Card className="p-6 border-white/10 bg-card">
          <div className="overline mb-3">Company directory</div>
          {company ? (
            <div>
              <div className="text-lg font-semibold">{company.name}</div>
              <div className="text-sm text-zinc-400">{company.category}</div>
              <div className="mt-2 flex items-center gap-2">
                <Badge variant="outline" className="border-white/10">Rating {company.rating}</Badge>
                <Badge variant="outline" className="border-white/10">{company.active ? "Active" : "Inactive"}</Badge>
              </div>
              <div className="text-xs text-zinc-500 mt-3">
                Insurance expires {company.insurance_expiry ? new Date(company.insurance_expiry).toLocaleDateString() : "—"}
              </div>
              <div className="text-xs text-zinc-500 mt-1">Properties assigned: {company.property_ids?.length || 0}</div>
            </div>
          ) : (
            <div className="text-sm text-muted-foreground">Your company hasn't been onboarded to any properties yet.</div>
          )}
        </Card>
      </div>
    </div>
  );
}
